import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import { env } from '@/config';

Sentry.init({
  dsn: 'https://4dc1153d95fda7b862f4d3a99b208f8b@sentry.raysyun.com/1',
  integrations: [new Integrations.BrowserTracing()],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
  environment: env,
  maxBreadcrumbs: 5,
  beforeSend(event) {
    // 被捕获事件，不上报
    // 音视频无法播放，不上报
    if(event.message && (event.message.includes('CAPTURED') || event.message.includes('ALLOW'))) {
      return null;
    }
    // 被捕获事件，不上报
    if(event.exception && event.exception.values) {
      if(event.exception.values instanceof Array) {
        if(event.exception.values.some(v => v.value && String(v.value).includes('CAPTURED'))) {
          return null;
        }
      }
    }

    return event;
  }

});

export default Sentry;
